import { Head, useForm } from '@inertiajs/react'
import { FormEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

interface Props {
  token: string
  flash: {
    alert?: string
  }
}

export default function Edit({ token, flash }: Props) {
  const { t } = useTranslation()
  const { data, setData, put, processing } = useForm({
    password: '',
    password_confirmation: '',
  })

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    put(`/passwords/${token}`)
  }

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Head title={t('auth.resetPassword.title')} />

      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-2xl">{t('auth.resetPassword.title')}</CardTitle>
          <CardDescription>
            {t('auth.resetPassword.description')}
          </CardDescription>
        </CardHeader>

        <CardContent>
          {flash.alert && (
            <div className="mb-4 rounded-md bg-destructive/10 p-3 text-sm text-destructive">
              {flash.alert}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="password">{t('auth.resetPassword.newPassword')}</Label>
              <Input
                id="password"
                type="password"
                placeholder={t('auth.resetPassword.newPasswordPlaceholder')}
                value={data.password}
                onChange={(e) => setData('password', e.target.value)}
                required
                autoFocus
                autoComplete="new-password"
                maxLength={72}
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password_confirmation">{t('auth.resetPassword.confirmPassword')}</Label>
              <Input
                id="password_confirmation"
                type="password"
                placeholder={t('auth.resetPassword.confirmPasswordPlaceholder')}
                value={data.password_confirmation}
                onChange={(e) => setData('password_confirmation', e.target.value)}
                required
                autoComplete="new-password"
                maxLength={72}
              />
            </div>

            <div className="pt-2">
              <Button type="submit" disabled={processing}>
                {processing ? t('auth.resetPassword.submitting') : t('auth.resetPassword.submit')}
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
